/**
 * Slot width (px)
 */
export const SLOT_SPACING = 2;
export const SLOT_WIDTH = 200;
export const SLOT_WIDTH_MOBILE = 180;
